/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Modal
 */
import { ModalFuncProps } from 'antd';
import { AntClass } from 'app-constants/antd';

const ModalSubtitle: React.FC<{ subtitle: React.ReactNode; content?: React.ReactNode }> = ({ subtitle, content }) => {
	return (
		<>
			<div className={AntClass.modalConfirmSubtitle}>{subtitle}</div>
			{content}
		</>
	);
};

/**
 * MODAL_TYPES
 * @type {string}
 */
const MODAL_TYPES: Record<ModalFuncProps['type'], ModalFuncProps> = {
	confirm: {
		title: 'Confirmation',
		closable: true,
	},
	info: {
		title: 'Information',
		closable: true,
	},
	warning: {
		title: 'Warning',
		closable: true,
	},
	error: {
		title: 'Error',
		closable: true,
	},
	success: {
		title: 'Success',
		closable: true,
	},
	warn: {
		title: 'Warning',
		closable: true,
	},
};

export { MODAL_TYPES, ModalSubtitle };
